var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabNavigation',{attrs:{"items":_vm.items},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('template',{slot:"content1"},[_c('div',{staticClass:"mx-10"},[_c('StudentDetailUpdatesPending')],1)]),_c('template',{slot:"content2"},[_c('div',{staticClass:"mx-10"},[_c('StudentDetailUpdatesProcessed')],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }